import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=5b0932f6&scoped=true"
import script from "./BasicInput.vue?vue&type=script&lang=ts"
export * from "./BasicInput.vue?vue&type=script&lang=ts"
import style0 from "./BasicInput.vue?vue&type=style&index=0&id=5b0932f6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0932f6",
  null
  
)

export default component.exports